export const isProduction = () => {
  try {
    return (
      typeof window !== 'undefined' &&
      window?.location?.hostname === 'www.storebrand.no'
    );
  } catch {
    return false;
  }
};
